import { createContext, type PropsWithChildren, useContext } from 'react'
import type { DashboardContextType } from '../types'

const DashboardContext = createContext<DashboardContextType>({
  userIds: [],
  isUserIdsLoading: false,
  agencyId: null
})

export const useDashboardContext = () => useContext(DashboardContext)

type DashboardProviderProps = PropsWithChildren<{
  userIds: number[]
  isUserIdsLoading: boolean
  agencyId: number | null
}>

export const DashboardProvider = ({
  children,
  userIds,
  isUserIdsLoading,
  agencyId
}: DashboardProviderProps) => (
  <DashboardContext.Provider
    value={{
      userIds,
      isUserIdsLoading,
      agencyId
    }}
  >
    {children}
  </DashboardContext.Provider>
)
